// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/WebFont/ToyotaType-Book.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'ToyotaTypeBook';
}

.home,
.reports,
.products,
.team,
.reports {
  align-items: center;
  justify-content: center;
}
.search .fa-search { 
  position: absolute;
  top: 5px;
  left: 7px;
  border: none;
}


.row .label_control{
  margin-bottom:0px;
  padding-bottom:0px;
}
.three_column{
  float:left;
}
@font-face {
  font-family: "ToyotaTypeBook";
  src: local("ToyotaTypeBook"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.centerContents{
  position: absolute;
  left: 50%;
  top: 50%;
}
body{
  background: #f3f2f2;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;;;;EAKE,mBAAmB;EACnB,uBAAuB;AACzB;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B;8DACqE;EACrE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'ToyotaTypeBook';\n}\n\n.home,\n.reports,\n.products,\n.team,\n.reports {\n  align-items: center;\n  justify-content: center;\n}\n\n@import url(\"//maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css\");\n.search .fa-search { \n  position: absolute;\n  top: 5px;\n  left: 7px;\n  border: none;\n}\n\n\n.row .label_control{\n  margin-bottom:0px;\n  padding-bottom:0px;\n}\n.three_column{\n  float:left;\n}\n@font-face {\n  font-family: \"ToyotaTypeBook\";\n  src: local(\"ToyotaTypeBook\"),\n    url(\"../src/assets/WebFont/ToyotaType-Book.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n.centerContents{\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\nbody{\n  background: #f3f2f2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
